/**
 * @generated SignedSource<<0a7ecdcfd35690478c3a290bef83ae30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CampaignPrType = "product_offer" | "rewarded";
export type MediaType = "cast" | "ins_highlight" | "ins_image" | "ins_live" | "ins_reel_story" | "ins_story" | "ins_video" | "other" | "tiktok" | "tiktok_go" | "twitter_image" | "twitter_video" | "youtube" | "youtube_short";
import { FragmentRefs } from "relay-runtime";
export type ApplyReward$data = {
  readonly advertiserName: string | null;
  readonly askingPrice: number | null;
  readonly mediaType: MediaType;
  readonly prType: CampaignPrType | null;
  readonly " $fragmentType": "ApplyReward";
};
export type ApplyReward$key = {
  readonly " $data"?: ApplyReward$data;
  readonly " $fragmentSpreads": FragmentRefs<"ApplyReward">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ApplyReward",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "advertiserName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "askingPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prType",
      "storageKey": null
    }
  ],
  "type": "Campaign",
  "abstractKey": null
};

(node as any).hash = "030f3552e1056eccce58c3cd1cc67535";

export default node;
